import React, { useReducer } from 'react'
import { reducer } from './reducer'
import defaultGroups from './groups.yml'
import defaultQuestions from './questions.yml'
import { DispatchContext, StateContext } from './contexts'
import { Survey } from './components/survey'
import { Results } from 'components/questionnaire/components/results'

export function Questionnaire() {
  const [state, dispatch] = useReducer(reducer, {})

  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>
        <Survey groups={defaultGroups} questions={defaultQuestions} />
        <Results questions={defaultQuestions} threshold={37} />
      </StateContext.Provider>
    </DispatchContext.Provider>
  )
}
